import { ICustomer } from '@/interfaces/customer';
import { ILocationCheckingRes } from '@/interfaces/location';

const getFullAddress = (customer?: ICustomer) => {
  if (!customer) return '';
  return `${customer.address || ''} ${customer.road || ''} ${customer.subdistrictNameTh || ''} ${customer.districtNameTh || ''} ${customer.provinceNameTh || ''} ${customer.postalCode || ''}`;
};

const getFullAddressEn = (customer?: ICustomer) => {
  if (!customer) return '';
  return `${customer.address || ''} ${customer.road || ''} ${customer.subdistrictNameEn || ''} ${customer.districtNameEn || ''} ${customer.provinceNameEn || ''} ${customer.postalCode || ''}`;
};

const getFullLocationAddress = (customer?: ILocationCheckingRes) => {
  if (!customer) return '';
  return `${customer.address || ''} ${customer.subdistrictNameTh || ''} ${customer.districtNameTh || ''} ${customer.provinceNameTh || ''} ${customer.postalCode || ''}`;
};

export { getFullAddress, getFullAddressEn, getFullLocationAddress };
